
import { Payload } from "@src/api/payload.class";
import { SETTLEMENT_DATA_REQUEST, OVERVIEW_DATA_ERROR, SETTLEMENT_DATA_LOADING, OVERVIEW_DATA_REQUEST_SUCCESS, OVERVIEW_DATA_LOADING, SETTLEMENT_TINFILTER_DATA_SUCCESS, SETTLEMENT_TINFILTER_DATA_REQUEST, FILTER_TIME_PERIOD_SUCCESS, FILTER_LOB_SUCCESS, FILTER_TAXID_SUCCESS, SETTLEMENT_TINFILTER_DATA_LOADING, SETTLEMENT_PAYMENT_DATA_SUCCESS, SETTLEMENT_PAYMENT_DATA_LOADING, SETTLEMENT_PAYMENT_DATA_REQUEST, SETTLEMENT_CURRENT_FLOW, SETTLEMENT_TREND_DATA_REQUEST, SETTLEMENT_VOLUME_DATA_REQUEST, SETTLEMENT_VOLUME_DATA_SUCCESS, SETTLEMENT_VOLUME_DATA_LOADING, SETTLEMENT_TREND_MEDICAID_REQUEST, SETTLEMENT_TREND_MEDICARE_REQUEST, SETTLEMENT_TREND_UNCATERGORIZED_REQUEST, SETTLEMENT_TREND_COMMERCIAL_REQUEST, OVERVIEW_DATA_REQUEST, SETTLEMENT_TREND_COMMERCIAL_SUCCESS, SETTLEMENT_TREND_MEDICARE_SUCCESS, SETTLEMENT_TREND_UNCATERGORIZED_SUCCESS, SETTLEMENT_TREND_MEDICAID_SUCCESS, SETTLEMENT_TREND_SUCCESS, SETTLEMENT_TREND_DATA_LOADING, SETTLEMENT_MEDICARE_DATA_LOADING, SETTLEMENT_MEDICAID_DATA_LOADING, SETTLEMENT_COMMERCIAL_DATA_LOADING, SETTLEMENT_UNCATEGORIZED_DATA_LOADING, SETTLEMENT_DETAILS_DATA_REQUEST, SETTLEMENT_DETAILS_DATA_SUCCESS, SETTLEMENT_DETAILS_DATA_LOADING, SETTLEMENT_GEOFILTER_DATA_REQUEST, SETTLEMENT_GEOFILTER_DATA_SUCCESS, SETTLEMENT_EMPTY_DATA, SETTLEMENT_GEOFILTER_REGION, SETTLEMENT_GEOFILTER_STATE, SETTLEMENT_GEOFILTER_MARKET, SETTLEMENT_RESET_STATE, GEO_STATE_HOME_VAL_CHECK } from "../actionTypes";


export const fetchSettlementOverviewData = (payload: any) => ({
    type: OVERVIEW_DATA_REQUEST,
    payload
});

export const fetchOverviewDataSuccess = (payload: any) => ({
    type: OVERVIEW_DATA_REQUEST_SUCCESS,
    payload
});

export const overviewDataLoading = (payload: any) => ({
    type: OVERVIEW_DATA_LOADING,
    payload
});

export const paymentDataActionLoading = (payload: any) => ({
    type: SETTLEMENT_PAYMENT_DATA_LOADING,
    payload
});

export const fetchOverviewError = (payload: any) => ({
    type: OVERVIEW_DATA_ERROR,
    payload
});

export const fetchSettlementDataLoading = (payload: any) => ({
    type: SETTLEMENT_DATA_LOADING,
    payload
});

export const quickFilterTinDataLoading = (payload: any) => ({
    type: SETTLEMENT_TINFILTER_DATA_LOADING,
    payload
});
export const settlementTinFilterDataRequestAction = (payload: any) => ({
    type: SETTLEMENT_TINFILTER_DATA_REQUEST,
    payload
});
export const settlementTinFilterDataSuccessAction = (payload: any) => ({
    type: SETTLEMENT_TINFILTER_DATA_SUCCESS,
    payload
});
export const timePeriodDataStoreAction = (payload: any) => ({
    type: FILTER_TIME_PERIOD_SUCCESS,
    payload
});
export const lobDataStoreAction = (payload: any) => ({
    type: FILTER_LOB_SUCCESS,
    payload
});
export const taxIdDataStoreAction = (payload: any) => ({
    type: FILTER_TAXID_SUCCESS,
    payload
});
export const fetchSettlementPaymentData = (payload: any) => ({
    type: SETTLEMENT_PAYMENT_DATA_SUCCESS,
    payload
});
export const fetchSettlementDataRequest = (payload: any) => ({
    type: SETTLEMENT_PAYMENT_DATA_REQUEST,
    payload
});
export const fetchSettlementCurrentFlow = (payload: any) => ({
    type: SETTLEMENT_CURRENT_FLOW,
    payload
});
export const fetchTrendData = (payload: any) => ({
    type: SETTLEMENT_TREND_DATA_REQUEST,
    payload
});
export const setSettlementTrendDataRequest = (payload: any) => ({
    type: SETTLEMENT_TREND_DATA_REQUEST,
    payload,
});
export const fetchVolumeDataRquest = (payload: any) => ({
    type: SETTLEMENT_VOLUME_DATA_REQUEST,
    payload,
})
export const setSettlementVolumeDataSuccess = (payload: any) => ({
    type: SETTLEMENT_VOLUME_DATA_SUCCESS,
    payload,
});
export const paymentVolumeActionLoading = (payload: any) => ({
    type: SETTLEMENT_VOLUME_DATA_LOADING,
    payload,
});
export const setMedicaidData = (payload: any) => ({
    type: SETTLEMENT_TREND_MEDICAID_REQUEST,
    payload,
});
export const setMedicareData = (payload: any) => ({
    type: SETTLEMENT_TREND_MEDICARE_REQUEST,
    payload,
});
export const setUncategorizedData = (payload: any) => ({
    type: SETTLEMENT_TREND_UNCATERGORIZED_REQUEST,
    payload,
});
export const setCommercialData = (payload: any) => ({
    type: SETTLEMENT_TREND_COMMERCIAL_REQUEST,
    payload,
});
export const fetchMedicaidData = (payload: any) => ({
    type: SETTLEMENT_TREND_MEDICAID_SUCCESS,
    payload,
});
export const fetchMedicareData = (payload: any) => ({
    type: SETTLEMENT_TREND_MEDICARE_SUCCESS,
    payload,
});
export const fetchCommercialData = (payload: any) => ({
    type: SETTLEMENT_TREND_COMMERCIAL_SUCCESS,
    payload,
});
export const fetchUncategorizedData = (payload: any) => ({
    type: SETTLEMENT_TREND_UNCATERGORIZED_SUCCESS,
    payload,
});
export const fetchtTrendDataSuccess = (payload: any) => ({
    type: SETTLEMENT_TREND_SUCCESS,
    payload,
});
export const trendDataLoading = (payload: any) => ({
    type: SETTLEMENT_TREND_DATA_LOADING,
    payload,
});
export const medicareDataLoading = (payload: any) => ({
    type: SETTLEMENT_MEDICARE_DATA_LOADING,
    payload,
});
export const medicaidDataLoading = (payload: any) => ({
    type: SETTLEMENT_MEDICAID_DATA_LOADING,
    payload,
});
export const commercialDataLoading = (payload: any) => ({
    type: SETTLEMENT_COMMERCIAL_DATA_LOADING,
    payload,
});
export const uncategorizedDataLoading = (payload: any) => ({
    type: SETTLEMENT_UNCATEGORIZED_DATA_LOADING,
    payload,
});

export const fetchSettlementDetailsRequest = (payload: any) => ({
    type: SETTLEMENT_DETAILS_DATA_REQUEST,
    payload
})

export const setSettlementDetailsSuccess = (payload: any) => ({
    type: SETTLEMENT_DETAILS_DATA_SUCCESS,
    payload
});

export const settlementDetailsLoading = (payload: any) => ({
    type: SETTLEMENT_DETAILS_DATA_LOADING,
    payload
});
export const geoFilterDataRequestAction = (payload: any) => ({
    type: SETTLEMENT_GEOFILTER_DATA_REQUEST,
    payload
});
export const geoFilterDataSuccessAction = (payload: any) => ({
    type: SETTLEMENT_GEOFILTER_DATA_SUCCESS,
    payload
});
export const settlementEmptyData = (payload: any) => ({
    type: SETTLEMENT_EMPTY_DATA,
    payload
});


export const settlementResetState = () => ({
    type: SETTLEMENT_RESET_STATE
});
 
export const setttlementgeoRegion = (payload: any) => ({
    type: SETTLEMENT_GEOFILTER_REGION,
    payload
});
export const setttlementgeoState = (payload: any) => ({
    type: SETTLEMENT_GEOFILTER_STATE,
    payload
});
export const setttlementgeoMarket = (payload: any) => ({
    type: SETTLEMENT_GEOFILTER_MARKET,
    payload
});
export const setttlementgeoValCheck = (payload: any) => ({
    type: GEO_STATE_HOME_VAL_CHECK,
    payload
});
